import React, { useState, useContext, useEffect } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CartItem from "./CartItem";
import Payment from "./Payment";
import { CustomerContext } from "../CashierHomepage";
import { CustomerIdContext } from "../../context/CustomerIdProvider";
import ClearCart from "./ClearCart";

function CartTable() {
  const { selectedCustomerName, currency } = useContext(CustomerContext);
  const { selectedCustomerId } = useContext(CustomerIdContext);
  const [totalSum, setTotalSum] = useState(0);
  const [customerName, setCustomerName] = useState(selectedCustomerName);

  useEffect(() => {
    if (selectedCustomerName) {
      setCustomerName(selectedCustomerName);
    }
  }, [selectedCustomerName, selectedCustomerId]);

  return (
    <div className="  min-h-full">
      <div className="px-3">
        <div className="flex flex-row  justify-center gap-5 bg-gray-900  py-1 items-center">
          <ClearCart id={selectedCustomerId} />
          <div className="flex gap-2">
            <AccountCircleIcon />
            <h4>{customerName}</h4>
          </div>
        </div>
      </div>

      {/* Table starts here */}
      <div className="flex flex-col  justify-between h-[calc(100vh-80px)] px-3 pb-5 overflow-y-auto  scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
        <div>
          <table className="min-w-full  border border-gray-300">
            <thead>
              <tr
              // className="bg-gray-200"
              >
                <th className="py-2 px-1 border-b border-gray-300">#</th>
                <th className="py-2 px-2 border-b border-gray-300">Menu</th>
                <th className="py-2 px-2 border-b border-gray-300">Price</th>
                <th className="py-2 px-2 border-b border-gray-300">Quantity</th>
                <th className="py-2 px-2 border-b border-gray-300 text-wrap">
                  Actions
                </th>
              </tr>
            </thead>

            <CartItem setTotalSum={setTotalSum} currency={currency} />
          </table>
          <div className="flex flex- py-2 border-2 border-gray-200 border-b-2 justify-evenly">
            <h3>Total</h3>
            <h3>
              {currency}
              {totalSum ? totalSum.toFixed(2) : 0.0}
            </h3>
          </div>
        </div>

        {/* Buttons for functionality */}
        <div className="">
          <Payment currency={currency} />
        </div>
      </div>
    </div>
  );
}

export default React.memo(CartTable);
